exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#text[data-v-c4739a3c] {\n  width: 100%\n}\n.ptext[data-v-c4739a3c] {\n  padding: 5px;\n}\nem[data-v-c4739a3c] {\n  font-weight: 500\n}\n#card-image[data-v-c4739a3c] {\n  float: right;\n  max-width: 100%;\n  height: auto;\n}\n.message-body[data-v-c4739a3c] {\n  width: 80%;\n  font-size: 1.1em;\n}\n.message[data-v-c4739a3c] {\n  min-height: 248px;\n}\n\n\n", ""]);

// exports
